export default __webpack_public_path__ + "static/media/andean4.9d977b88.jpg";